import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { StaticPagesService } from '../../shared/services/static-page/static-pages.service';
import { RouterModule, RouterOutlet } from '@angular/router';
import { PageType } from '../../shared/models/enums/pageType';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
})
export class AboutUsComponent implements OnInit {
  constructor(
    private staticPagesService: StaticPagesService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  about: any;

  ngOnInit(): void {
    this.staticPagesService
      .getByPageType(PageType.About)
      .subscribe((data) => {
        this.about = data[0];
      });
  }
}
